import {BOARD_ID_NUM_DIGITS} from './../constants/globalConstants';

const generateNewBoardId = arrayOfIds => {
  return (Math.max(...arrayOfIds.map(id => parseInt(id, 10))) + 1).toString().padStart(BOARD_ID_NUM_DIGITS, '0');
};

export default generateNewBoardId;
